<template>
		<div  class="info-panel">
			<i class="big angle double left icon" @click="changePanelState()"></i>
      <div class=" metadata-container">
        <observation-metadata-info-panel-component v-if="observationsDetail != null" class="observation-details" :observationsDetail="observationsDetail"></observation-metadata-info-panel-component>
      </div>
    </div>
</template>

<style>
.info-panel {
  position: absolute;
  height: 100%;
  width: 1000px;
  top: 0;
  right: 0;
  z-index: 1000;
  padding-left: 40px;
  background-color: beige;
  overflow: auto;
  transition: all 0.4s ease-in-out;
  transform: translateX(calc(100% - 40px));
}

.info-panel.info-active {
  transform: translateX(0);
}

.angle.double.left.icon {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 0;
}

.metadata-container {
  position: absolute;
  padding-left: 10px;
  left: 50px;
  top:0;
  height:100%;
  width: calc(100% - 50px);
  overflow-y: auto;
  overflow-x: hidden;
}

</style>

<script>
import observationMetadataInfoPanelComponent from "./info-panel-components/observation-metadata-info-panel-component.vue";
import { mapGetters } from "vuex";

export default {
  components: { observationMetadataInfoPanelComponent },
  data() {
    return {
      //detail about the observation to print in the info panel
      observationsDetail: null,
    };
  },
  computed: {
    //Computed properties to enable component reactivity
    ...mapGetters(["getObservationsDetailed"]),
  },
  methods: {
    /**
     * Method to open the panel or not
     */
    changePanelState() {
      this.$el.classList.toggle("info-active");
    },
    /**
     * Method to get observation detailed info from Vuex observation store getter
     * If the panel is closed, it is opened
     */
    showObservationMetadata() {
      this.observationsDetail = this.getObservationsDetailed;
      if (this.$el.className === "info-panel") {
        this.changePanelState();
      }
    }
  },
  created() {
    /**
     * Event listener: on "showObservationMetadata" the panel is opened and details about one pbservation are presented.
     * Event bus pattern
     */
    this.$root.$on("showObservationMetadata", id => {
      this.showObservationMetadata();
    });
  }
};
</script>